Vue.component('ack-curo-resins-product-logo', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-curo-resins-product-logo',
    mounted() {
      if (this.menuItems?.length > 0) {
        this.menuItemClick(this.menuItems[0])
      }
    },
    props:{
      menuItems: { // :product-info
        type: Array,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      },
      activeItem: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...Vuex.mapGetters('resins', ['activeItem']),
      itemClass() {
        return this.menuItems.length === 3 ? 'justify-content-center' : 'justify-content-start'
      }

    },
    data() {
      return {
      }
    },
    methods: {
      ...Vuex.mapActions('resins', ['menuItemClick'])
    },
    beforeDestroy() {

    },
    watch: {
      prop1: {
        handler() {


        },
        deep: false
      }
    }
  })